import { useTranslation } from '@multaqa/i18n'
import { RecordHistoryPanel } from '@/components/record-history-panel'
import { useEffectiveGrants } from '@/lib/me'

/**
 * The "who changed this, and what" button of a record page (WP12). It opens
 * the shared history panel for one record, and is offered only to someone who
 * may read the audit trail. `recordType` is the audit trail's name for the
 * record: the model's name in snake case, e.g. `purchase_order`. `triggerLabel`
 * replaces the default "History" text for a screen that already names it.
 */
export function RecordHistoryButton({
  recordType,
  recordId,
  triggerLabel,
}: {
  recordType: string
  recordId: string
  triggerLabel?: string
}) {
  const { t } = useTranslation('common')
  const { can } = useEffectiveGrants()

  if (!can('audit.view')) return null

  return (
    <RecordHistoryPanel
      recordType={recordType}
      recordId={recordId}
      title={t('companyAudit.title')}
      triggerLabel={triggerLabel}
    />
  )
}
